module.exports = __webpack_public_path__ + "media/images/es/how-works-icon-3-fb5db0dd89e535b1fe9756122db93b18.png";